
<router-outlet></router-outlet>


<magenty-confirm-dialog></magenty-confirm-dialog>
<magenty-error-message></magenty-error-message>
<magenty-info-message></magenty-info-message>